import state from './state'

export default {
  user_profile: state => state.user_profile,
  isAdmin: state => state.user_profile.admin,
  tmp_task: state => state.tmp_task,
  tmp_topic: state => state.tmp_topic
}
